module.exports = __webpack_public_path__ + "img/last-block-img.24199d87.png";